export const routePreferenceOrder = ["cli", "graphql"] as const
